module.exports = __webpack_public_path__ + "static/media/kiosk.3740b883.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/marketing/kiosk.jpg
// module id = 13905
// module chunks = 0